<template>
  <b-modal ref="modal" title="Tu Pedido" centered>
    <TitleLine title="Base" />
    <template v-if="hasAditions">
      <div v-for="composition in order.compositions" :key="composition.id">
        {{ composition.name }}
      </div>
    </template>
    <div v-else>Sin productos base.</div>

    <TitleLine class="mt-3" title="Adiciones" />
    <template v-if="hasAditions">
      <div v-for="adition in order.aditions" :key="adition.id" class="mt-2">
        <b>
          {{ adition.quantity }}
        </b>
        {{ adition.name }}

        <v-btn
          class="ml-3"
          color="#8643bb"
          dark
          fab
          height="28"
          width="28"
          x-small
          @click="onDelete(adition)"
        >
          x
        </v-btn>
      </div>
    </template>
    <div v-else>Sin adiciones.</div>
  </b-modal>
</template>

<script>
import { Component, Mixins } from 'vue-property-decorator'

import Order from '@/models/order.model'
import CompositionOrder from '@/models/compositionOrder.model'

import ModalMixin from 'Mixins/ModalMixin'

@Component
export default class MinicartModal extends Mixins(ModalMixin) {
  get order() {
    return Order.query().first()
  }

  get hasAditions() {
    return this._.get(this.order, 'aditions', []).length > 0
  }

  async onDelete(adition) {
    await CompositionOrder.delete(adition.id)
    this.$emit('updateOrder')
  }
}
</script>

<style scoped></style>
